import React from 'react'

import { BaseItemsByOrganizationWidget } from './BaseItemsByOrganizationWidget'

export const DeckItemsByOrganizationWidget = () => {
  return <BaseItemsByOrganizationWidget section="deck" loadingKey="overviewPage" />
}
